import { DataTable } from "@msuite/ui/table";
import { WorkspaceTag } from "@msuite/ui/tag";
import { TimelineWeeklyControls, useTimelineWeeklyControls } from "@msuite/ui/timeline";
import { usePartnerTimeline } from "@/hooks/use-partner-timeline";
import type { PartnerPanelBaseProps } from "../types";
import { columns } from "./table-config";

export function PartnerTimelineInvoiceTracking({ partnershipId }: PartnerPanelBaseProps) {
	/** Hooks */
	const { currentWeek } = useTimelineWeeklyControls();

	/** Query */
	const { data, isLoading, refetch, queryKey } = usePartnerTimeline({ partnershipId, currentWeek });

	/** Render */
	return (
		<div className="p-1 h-full">
			<DataTable
				data={data?.invoiceTracking}
				columns={columns}
				persistenceKey="partner-timeline-invoice-tracking-table"
				isLoading={isLoading}
				queryKey={queryKey}
				grouping={["workspaceId"]}
				initialColumnVisibility={{
					workspaceId: false,
				}}
				initialPinningState={{
					start: ["invoiceNumber"],
				}}
				renderGroupHeader={(row) => (
					<WorkspaceTag
						workspace={{
							name: row.original.workspaceName,
							color: row.original.workspaceColor,
						}}
					/>
				)}
				menu={
					<TimelineWeeklyControls
						queryKey={queryKey}
						withRefreshButton={false}
					/>
				}
				refetch={refetch}
			/>
		</div>
	);
}
